import {
  LANGUAGE_LOADING,
  LANGUAGE_ADD,
  LANGUAGE_DELETE,
  LANGUAGE_LIST,
} from "actions/language/types";

const initialState = {
  loading: false,
  list: {
    content: []
  }
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LANGUAGE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case LANGUAGE_ADD:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          total_count: state.list.total_count++,
          content: state.list.content.concat(action.payload)
        },
      };
    case LANGUAGE_DELETE:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          total_count: state.list.total_count--,
          content: state.list.content.filter(i => i.id !== action.payload.id)
        }
      };
    case LANGUAGE_LIST:
      return {
        ...state,
        loading: false,
        list: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/languageReducer.js